import { render, staticRenderFns } from "./PsapSelect.vue?vue&type=template&id=328b7cb2&scoped=true"
import script from "./PsapSelect.vue?vue&type=script&lang=ts"
export * from "./PsapSelect.vue?vue&type=script&lang=ts"
import style0 from "./PsapSelect.vue?vue&type=style&index=0&id=328b7cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b7cb2",
  null
  
)

export default component.exports